import { AxiosResponse } from 'axios';
import api from './Api'

export const getPolicyDataTransferByMemberId = (memberId: string): Promise<AxiosResponse<IPolicyDataTransfer, any>> => {
    return api.get(`/policy_data_transfer/${memberId}`);
}
export const getPolicyDataTransferByToken = (): Promise<AxiosResponse<IPolicyDataTransfer, any>> => {
    return api.get(`/policy_data_transfer/token`);
}
export const createOrUpdatePolicyDataTransferAgree = (policyDataTransferRequest: IPolicyDataTransferRequest): Promise<AxiosResponse<any, any>> => {
    return api.put(`/policy_data_transfer/agree`, policyDataTransferRequest);
}
export const updatePolicyDataTransferAgree = (policyDataTransferRequest: IPolicyDataTransferPutRequest): Promise<AxiosResponse<any, any>> => {
    return api.put(`/policy_data_transfer/agree`, policyDataTransferRequest);
}

export const getCommunityPolicyIsCommunityPolicyChecked = () => {
    return api.get<boolean>(`/community_policy/is_community_policy_checked/web`);
}
export const createCommunityPolicyByCommunityPolicyCreateWebRequest = (communityPolicyCreateWebRequest: ICommunityPolicyCreateWebRequest) => {
    return api.post<boolean>(`/community_policy/is_community_policy/web`, communityPolicyCreateWebRequest);
}